module.exports = __webpack_public_path__ + "media/images/visa1-66839a9c68d838f0f89b230021aa1e59.png";